module.exports = __webpack_public_path__ + "img/English.ad4ad04d.png";